import { StudentResultAnswerStates } from "../helpers/StudentResultModel";

export interface AnswerStateStyles {
    /** The answer surface behind the student's text. */
    background: string;
    /** The student's text itself. */
    text: string;
    /** The thick edge joining a connect-words pair: the left card's right edge, the right card's left edge. */
    jointLeft: string;
    jointRight: string;
}

/**
 * The one place a state becomes colours, so every exercise type's answer layout shows the same
 * verdict the same way. Partial is styled although nothing produces it until HALLOFUSS-6682.
 */
const stylesByState: Record<StudentResultAnswerStates, AnswerStateStyles> = {
    [StudentResultAnswerStates.CORRECT]: {
        background: "bg-forest-green-pastel",
        text: "text-p6-green",
        jointLeft: "border-r-p6-green-mid",
        jointRight: "border-l-p6-green-mid",
    },
    [StudentResultAnswerStates.PARTIALLY_CORRECT]: {
        background: "bg-background-light",
        text: "text-p6-grey-dark",
        jointLeft: "border-r-p6-grey-dark",
        jointRight: "border-l-p6-grey-dark",
    },
    [StudentResultAnswerStates.INCORRECT]: {
        background: "bg-p6-red-light-pastel",
        text: "text-p6-red-darker",
        jointLeft: "border-r-p6-red",
        jointRight: "border-l-p6-red",
    },
    [StudentResultAnswerStates.NO_ANSWER]: {
        background: "bg-white",
        text: "text-p6-grey-mid",
        jointLeft: "border-r-p6-grey-dark",
        jointRight: "border-l-p6-grey-dark",
    },
};

export const getAnswerStateStyles = (state: StudentResultAnswerStates): AnswerStateStyles => stylesByState[state];
